import { render, staticRenderFns } from "./FaturacaoFilterModal.vue?vue&type=template&id=28af98d6&scoped=true&"
import script from "./FaturacaoFilterModal.vue?vue&type=script&lang=js&"
export * from "./FaturacaoFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af98d6",
  null
  
)

export default component.exports